
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1(160|453|955)|5535)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
